export enum SensorChartType {
    TIME = "TIME",
    STACKED = "STACKED",
    COMBINED = "COMBINED",
    HEATMAP = "HEATMAP",
}

export enum ChartSource {
    GATEWAY = "GATEWAY",
    GATEWAY2 = "GATEWAY2",
    SENSOR = "SENSOR",
    ACTUATOR = "ACTUATOR",
    OTHER = "OTHER",
    AGGREGATION = "AGGREGATION",
}

// This is based on the chart design
export const MAX_CHART_VALUE_CHARS = 8;
